/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { ComparePage } from 'landing-pages/compare/ComparePage';
import { getMoodysCompareData } from 'landing-pages/compare/data/moodys';

export const GlobalDatabaseVsMoodysPage = () => {
  const { t } = useInt();

  return <ComparePage data={getMoodysCompareData(t)} />;
};
